<template>
    <div id="dashboard_crm px-6">
        <div class="vx-row match-height">
            <div class="vx-col lg:w-1/3 w-full">
                <div class="vx-card p-2">
                    <span class="text-base font-medium">Khách hàng trong quy trình hôm nay</span>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vue-apex-charts type="radialBar" height="350" :options="medicalExaminationData.chartOptions"
                                             :series="medicalExaminationData.series"></vue-apex-charts>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col lg:w-2/3 w-full">
                <div class="vx-row match-height">
                    <div class="vx-col sm:w-1/2 lg:mt-0 mt-6 w-full card_customer_service">
                        <div class="vx-card px-4 py-2">
                            <span class="text-base font-medium">Khách hàng chờ xử lý</span>
                            <div class="vx-row">
                                <div class="vx-col w-1/4 m-auto">
                                    <h1 style="color: rgba(var(--vs-warning), 1)">{{ totalCustomerWaiting.total }}</h1>
                                </div>
                                <div class="vx-col w-3/4">
                                    <vue-apex-charts type="bar" height="100" ref="totalCustomerWaiting"
                                                     :options="totalCustomerWaiting.chartOptions"
                                                     :series="totalCustomerWaiting.series"></vue-apex-charts>
                                </div>
                            </div>
                            <span class="text-base font-medium">Trong 7 ngày qua</span>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 lg:mt-0 mt-6 w-full card_customer_service">
                        <div class="vx-card px-4 py-2">
                            <span class="text-base font-medium">Khách hàng xác nhận làm dịch vụ</span>
                            <div class="vx-row">
                                <div class="vx-col w-1/4 m-auto">
                                    <h1 style="color: rgba(var(--vs-success), 1)">{{ totalCustomerConfirm.total }}</h1>
                                </div>
                                <div class="vx-col w-3/4">
                                    <vue-apex-charts type="bar" height="100" ref="totalCustomerConfirm"
                                                     :options="totalCustomerConfirm.chartOptions"
                                                     :series="totalCustomerConfirm.series"></vue-apex-charts>
                                </div>
                            </div>
                            <span class="text-base font-medium">Trong 7 ngày qua</span>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 mt-6 w-full card_customer_service">
                        <div class="vx-card px-4 py-2">
                            <span class="text-base font-medium">Khách hàng hủy dịch vụ</span>
                            <div class="vx-row">
                                <div class="vx-col w-1/4 m-auto">
                                    <h1 style="color: rgba(var(--vs-danger), 1)">{{ totalCustomerCancel.total }}</h1>
                                </div>
                                <div class="vx-col w-3/4">
                                    <vue-apex-charts type="bar" height="100" ref="totalCustomerCancel"
                                                     :options="totalCustomerCancel.chartOptions"
                                                     :series="totalCustomerCancel.series"></vue-apex-charts>
                                </div>
                            </div>
                            <span class="text-base font-medium">Trong 7 ngày qua</span>
                        </div>
                    </div>
                    <div class="vx-col sm:w-1/2 mt-6 w-full card_customer_service">
                        <div class="vx-card px-4 py-2">
                            <span class="text-base font-medium">Khách hàng hoàn thành dịch vụ</span>
                            <div class="vx-row">
                                <div class="vx-col w-1/4 m-auto">
                                    <h1 style="color: rgba(var(--vs-primary), 1)">{{ totalCustomerComplete.total }}</h1>
                                </div>
                                <div class="vx-col w-3/4">
                                    <vue-apex-charts type="bar" height="100" ref="totalCustomerComplete"
                                                     :options="totalCustomerComplete.chartOptions"
                                                     :series="totalCustomerComplete.series"></vue-apex-charts>
                                </div>
                            </div>
                            <span class="text-base font-medium">Trong 7 ngày qua</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mt-6 match-height">
            <div class="vx-col lg:w-2/3 w-full">
                <div class="vx-card p-2">
                    <vue-apex-charts type="bar" height="350" ref="groupedCustomerType"
                                     :options="groupedCustomerType.chartOptions"
                                     :series="groupedCustomerType.series">
                    </vue-apex-charts>
                </div>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full lg:mt-0 mt-6">
                <div class="vx-card p-4">
                    <h2>Đánh giá dịch vụ</h2>
                    <div class="vx-row mt-6">
                        <div class="vx-col w-full">
                            <div class="star_rate flex">
                                <star-rating v-model="rate" :star-size="25" :show-rating="false" :read-only="true"
                                             :border-width="4" border-color="#F3D23E"
                                             active-color="#F3D23E" :rounded-corners="true"
                                             :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                             class="mt-2" :increment="0.1" :fixed-points="2"></star-rating>
                                <span class="ml-auto flex items-center"
                                      style="color: rgba(0, 0, 0, 0.30)">{{ rate }} /5</span>

                            </div>
                        </div>
                        <div class="vx-col w-full grid items-center" style="min-height: 250px">
                            <div class="vx-row" v-for="(item, ind) in feedbackRateData" :key="ind">
                                <div class="vx-col w-1/6 flex items-center">
                                    <span class="mr-2">{{ item.rate }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
                                         viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z"
                                            fill="#FEE501"/>
                                    </svg>
                                </div>
                                <div class="vx-col w-1/2 flex items-center">
                                    <vs-progress :percent="item.countPercentage" :height="15" color="#FEE501">primary
                                    </vs-progress>
                                </div>
                                <div class="vx-col w-1/3">
                                    <span>{{ item.countPercentage + '% / ' + item.count }}<span class="text-sm"> đánh giá</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-6">
                <div class="vx-card p-4">
                    <h2 class="mb-4">Dịch vụ nổi bật</h2>
                    <div class="vx-row" v-for="(data, ind) in popularServiceData" :key="ind">
                        <div class="vx-col w-2/3">
                            <div><span class="text-lg font-medium">{{data.name}}</span></div>
                            <span>{{data.code}}</span>
                        </div>
                        <span class="vx-col w-1/3 flex items-center text-3xl font-medium"
                              style="color: rgba(var(--vs-primary), 1);">{{data.count}}</span>
                        <vs-divider v-if="ind !== 6"/>
                    </div>
                </div>
            </div>
            <div class="vx-col lg:w-2/3 w-full mt-6">
                <div class="vx-card p-4">
                    <vue-apex-charts type="area" height="350" ref="inOutHistory"
                                     :options="inOutHistory.chartOptions"
                                     :series="inOutHistory.series">
                    </vue-apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import AwesomeVueStarRating from "awesome-vue-star-rating";
import StarRating from 'vue-star-rating';

export default {
    name: "DashboardCRM",
    components: {
        VueApexCharts,
        AwesomeVueStarRating,
        StarRating,
    },
    data() {
        return {
            medicalExaminationData: {
                series: [],
                chartOptions: {
                    chart: {
                        height: 390,
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 270,
                            hollow: {
                                margin: 5,
                                size: '30%',
                                background: 'transparent',
                                image: undefined,
                            },
                            dataLabels: {
                                value: {
                                    formatter: function (val, opts) {
                                        return (parseInt(val, 10)/opts.globals.series.reduce((accumulator, currentValue) => accumulator + currentValue, 0)*100).toFixed(2) + '%'
                                    }
                                }
                            }
                        }
                    },
                    labels: ['Chờ tiếp đón', 'Tiếp đón', 'Tư vấn', 'Thu phí', 'Cận lâm sàng', 'Hoàn thành'],
                    legend: {
                        show: true,
                        floating: true,
                        fontSize: '16px',
                        position: 'left',
                        labels: {
                            useSeriesColors: true,
                        },
                        markers: {
                            size: 0
                        },
                        formatter: function(seriesName, opts) {
                            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
                        },
                        itemMargin: {
                            vertical: 3
                        }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            legend: {
                                show: false
                            }
                        }
                    }]
                },
            },
            totalCustomerWaiting: {
                total: 0,
                series: [],
                chartOptions: {
                    chart: {
                        height: 100,
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['rgba(var(--vs-warning), 1)'],
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: function (val) {
                                return (val / 1000000).toFixed(0)
                            }
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            show: false,
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                    },
                },
            },
            totalCustomerConfirm: {
                total: 0,
                series: [],
                chartOptions: {
                    chart: {
                        height: 100,
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['rgba(var(--vs-success), 1)'],
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: function (val) {
                                return (val / 1000000).toFixed(0)
                            }
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            show: false,
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                    },
                },
            },
            totalCustomerCancel: {
                total: 0,
                series: [],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['rgba(var(--vs-danger), 1)'],
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: function (val) {
                                return (val / 1000000).toFixed(0)
                            }
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            show: false,
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                    },
                },
            },
            totalCustomerComplete: {
                total: 0,
                series: [],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['rgba(var(--vs-primary), 1)'],
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: function (val) {
                                return (val / 1000000).toFixed(0)
                            }
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            show: false,
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                    },
                },
            },
            groupedCustomerType: {
                series: [],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 3,
                            dataLabels: {
                                position: 'top', // top, center, bottom
                            },
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    title: {
                        text: 'Phân loại khách hàng',
                        align: 'left',
                        margin: 10,
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            fontFamily: ''
                        }
                    },
                    subtitle: {
                        text: 'Trong 7 ngày',
                        align: 'left',
                        margin: 10,
                        style: {
                            fontSize: '12px',
                            fontFamily: ''
                        }
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: true
                            }
                        }
                    },
                    markers: {
                        size: 0
                    },
                    xaxis: {
                        categories: [],
                        tooltip: {
                            enabled: false
                        },
                    },
                    colors: ['#3834E4', '#EB5818', '#31C237', '#EBBD18']
                },
            },
            rate: 5,
            feedbackRateData: [],
            inOutHistory: {
                series: [],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        categories: [],
                        tooltip: {
                            enabled: false
                        },
                    },
                    tooltip: {},
                    title: {
                        text: 'Thống kê khách hàng đến',
                        align: 'left',
                        margin: 10,
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            fontFamily: ''
                        }
                    },
                    subtitle: {
                        text: 'Trong 7 ngày',
                        align: 'left',
                        margin: 10,
                        style: {
                            fontSize: '12px',
                            fontFamily: ''
                        }
                    },
                },
            },
            popularServiceData: [],
        }
    },

    async created() {
        // await this.getmedicalExamination();
        await this.getGroupStatusBooking();
        await this.getGroupedCustomerType();
        await this.getFeedbackRate();
        await this.getPopularService();
        await this.getInOutHistoryArrival();
    },
    mounted() {
        this.startPolling();
    },

    methods: {
        startPolling() {
            this.getmedicalExamination();
            setInterval(() => {
                this.getmedicalExamination();
            }, 300000);
        },
        getmedicalExamination() {
            return new Promise((resolve, reject) => {
                let payload = {
                    startDate: new Date(new Date().setHours(0,0,0,0)),
                    endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                }
                this.medicalExaminationData.series = []
                this.$crm.post('/setting-medical-examination-step/get-grouped-step-chart', payload).then(res => {
                    this.$vs.loading.close();
                    let result = res.data[0]
                    this.medicalExaminationData.series.push(result.arrivingCount, result.arrivedCount, result.adviseCount, result.collectFeeCount, result.subclinicalCount, result.completedCount);
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getGroupStatusBooking() {
            return new Promise((resolve, reject) => {
                let payload = {
                    startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)),
                    endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                }

                this.$vs.loading();
                this.$crm.post('/beauty-booking/get-grouped-status-count-chart', payload).then(res => {
                    this.$vs.loading.close();
                    let waitingCount = {
                            name: 'Chờ xử lý',
                            data: [],
                        },
                        confirmedCount = {
                            name: 'Xác nhận làm dịch vụ',
                            data: [],
                        },
                        cancelledCount = {
                            name: 'Hủy dịch vụ',
                            data: [],
                        },
                        completedCount = {
                            name: 'Hoàn thành dịch vụ',
                            data: [],
                        },
                        categories = [];
                    res.data.map(el => {
                        categories.push(el.date);
                        waitingCount.data.push(el.waitingCount);
                        confirmedCount.data.push(el.confirmedCount);
                        cancelledCount.data.push(el.cancelledCount);
                        completedCount.data.push(el.completedCount);
                        return el;
                    })
                    this.totalCustomerWaiting.series.push(waitingCount);
                    this.totalCustomerConfirm.series.push(confirmedCount);
                    this.totalCustomerCancel.series.push(cancelledCount);
                    this.totalCustomerComplete.series.push(completedCount);

                    this.totalCustomerWaiting.total = confirmedCount.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                    this.totalCustomerConfirm.total = waitingCount.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                    this.totalCustomerCancel.total = cancelledCount.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                    this.totalCustomerComplete.total = completedCount.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

                    this.$refs.totalCustomerWaiting.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })
                    this.$refs.totalCustomerConfirm.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })
                    this.$refs.totalCustomerCancel.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })
                    this.$refs.totalCustomerComplete.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })

                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getGroupedCustomerType() {
            return new Promise((resolve, reject) => {
                let payload = {
                    startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)),
                    endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                }
                this.$vs.loading();
                this.$crm.post('/beauty-medical-record/get-grouped-customer-type-chart', payload).then(res => {
                    this.$vs.loading.close();
                    let customerBuyMedicineCount = {
                            name: 'KH mua thuốc',
                            data: [],
                        },
                        customerDepositRefundCount = {
                            name: 'KH hoàn phí',
                            data: [],
                        },
                        customerGiveBackMedicineCount = {
                            name: 'KH trả lại thuốc',
                            data: [],
                        },
                        newCustomerAdviseCount = {
                            name: 'KH mới đến tư vấn',
                            data: [],
                        },
                        oldCustomerAdviseServiceCount = {
                            name: 'KH cũ tới tư vấn',
                            data: [],
                        },
                        oldCustomerExamineCount = {
                            name: 'KH cũ tái khám',
                            data: [],
                        },
                        oldCustomerUserServiceCount = {
                            name: 'KH cũ sử dụng dịch vụ',
                            data: [],
                        },
                        categories = [];
                    res.data.map(el => {
                        categories.push(el.date);
                        customerBuyMedicineCount.data.push(el.customerBuyMedicineCount);
                        customerDepositRefundCount.data.push(el.customerDepositRefundCount);
                        customerGiveBackMedicineCount.data.push(el.customerGiveBackMedicineCount);
                        newCustomerAdviseCount.data.push(el.newCustomerAdviseCount);
                        oldCustomerAdviseServiceCount.data.push(el.oldCustomerAdviseServiceCount);
                        oldCustomerExamineCount.data.push(el.oldCustomerExamineCount);
                        oldCustomerUserServiceCount.data.push(el.oldCustomerUserServiceCount);
                        return el;
                    })

                    this.groupedCustomerType.series.push(customerBuyMedicineCount, customerDepositRefundCount, customerGiveBackMedicineCount, newCustomerAdviseCount, oldCustomerAdviseServiceCount, oldCustomerExamineCount, oldCustomerUserServiceCount)
                    this.$refs.groupedCustomerType.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })
                    resolve(res);
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getFeedbackRate() {
            return new Promise((resolve, reject) => {
                let payload = {
                    // startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)),
                    // endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                }
                this.$vs.loading();
                this.$crm.post('/beauty-booking-feedback/get-feedback-rate-chart', payload).then(res => {
                    this.$vs.loading.close();
                    this.rate = res.data.totalPercentage;
                    this.feedbackRateData = res.data.beautyBookingFeedbackRatingChartDetails.reverse();
                    resolve(res)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getPopularService() {
            return new Promise((resolve, reject) => {
                let payload = {
                    // startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)),
                    // endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                    limit: 7,
                }

                this.$vs.loading();
                this.$crm.post('/beauty-service/get-popular-service-chart', payload).then(res => {
                    this.$vs.loading.close();
                    this.popularServiceData = res.data;
                    resolve(res);
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getInOutHistoryArrival() {
            return new Promise((resolve, reject) => {
                let payload = {
                    start: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)),
                    end: new Date(new Date().setHours(23, 59, 59, 999)),
                    faceType: 'loyalty-customer',
                }

                this.$vs.loading();
                this.$crm.post('/time-keeping/get-in-out-history-branch-grouped-arrival-chart', payload).then(res => {
                    this.$vs.loading.close();
                    let categories = [];
                    let series = {
                        name: 'Số KH đến',
                        data: [],
                    }
                    res.data.map(el => {
                        categories.push(el.organizationBranchName);
                        series.data.push(el.count);
                        return el;
                    })

                    this.inOutHistory.series.push(series);
                    this.$refs.inOutHistory.updateOptions({
                        xaxis: {
                            categories: categories
                        }
                    })
                    resolve(res);
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        }
    },
}
</script>

<style scoped lang="scss">
#dashboard_crm {
    .apexcharts-xaxis-tick {
        display: none !important;
    }
}

//@media not all and (min-width: 768px) {
//    .card_customer_service .vx-card {
//        height: 171px;
//    }
//}
//
//@media (max-width: 832px) and (min-width: 768px) {
//    .card_customer_service .vx-card {
//        height: 192px;
//    }
//}

.vs-divider {
    margin: 3px 0 !important;
}

.star_rate {
    background-color: rgba(217, 217, 217, 0.20);;
    padding: 5px 10px;
    border-radius: 20px;
}
</style>
